import { forwardRef } from 'react';

import { Button, CircularProgress } from '@mui/material';
import type { TreeItemProps } from '@mui/x-tree-view-pro';

import { SHOW_MORE_SUFFIX } from '../../constants';
import { DECOMPOSITION_TREE_TEST_ID } from '../../testIds';
import type { ExtraItemProps } from '../../types';
import { CustomTreeItemStyled, stripExtraItemProps } from './CustomTreeItemStyled';

type ShowMoreItemProps = TreeItemProps &
  Pick<ExtraItemProps, 'callbacks' | 'onShowMore' | 'loadingParentIds' | 'testIdScope'>;

export const ShowMoreItem = forwardRef<HTMLLIElement, ShowMoreItemProps>(function ShowMoreItem(props, ref) {
  const { callbacks, onShowMore, loadingParentIds, testIdScope } = props;
  const treeItemProps = stripExtraItemProps(props);
  const parentId = treeItemProps.itemId.replace(SHOW_MORE_SUFFIX, '');
  const isLoading = loadingParentIds?.has(parentId) ?? false;
  const isDisabled = isLoading;
  const handleShowMore = onShowMore ?? callbacks?.onShowMore;

  return (
    <CustomTreeItemStyled
      {...treeItemProps}
      ref={ref}
      data-testid={DECOMPOSITION_TREE_TEST_ID.showMoreItem(parentId, testIdScope)}
      label={
        <Button
          size='small'
          variant='text'
          disabled={isDisabled}
          data-testid={DECOMPOSITION_TREE_TEST_ID.showMoreButton(parentId, testIdScope)}
          startIcon={isLoading ? <CircularProgress size={12} /> : undefined}
          sx={{ textTransform: 'none', py: 0, minHeight: 24 }}
          onClick={(e) => {
            e.stopPropagation();
            if (!isDisabled) handleShowMore?.(parentId);
          }}
        >
          {isLoading ? 'Loading…' : 'Show more…'}
        </Button>
      }
    />
  );
});
